import axios from "axios";
import apiBuilder, { URL_PREFIX } from "./apiBuilder";

const userApi = {
  ...apiBuilder("users"),

  fetchMe: () =>
    axios.get(`${URL_PREFIX}/users/me`)
};

export default userApi;
